import detailStyles from '../ChallengeDetail.module.scss';

export const InteractiveDrawPrizesLevelDescription = () => {
    return (
        <div className={detailStyles.description}>
            <p>
                <div>
                    Чем больше игроков участвует в розыгрыше за серые билеты — тем больше сертификатов на 500₽ разыгрывается каждый день.
                </div>
            </p>
        </div>
    );
}